var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"mt-3",attrs:{"variant":"danger","show":""}},[_c('div',{staticClass:"alert-heading h4"},[_vm._v(_vm._s(_vm.$t('commonKeys.error')))]),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.error.response.data.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }